import { EEventActions } from '@/store/eventStore/EventStoreTypes'
import type { EventsLocales } from '@/types/lang/locales'

export const eventsEn: EventsLocales = {
    actions: {
        affectFilters: 'Affect filters to this event',
        affectFiltersTitle: 'Affect filters',
        affectFiltersDevice: "Confirm and affect to this event's devices",
        affectDevices: 'Affect filters to devices of this event',

        reinitializeFiltersDevicesTitle: "Reinitialize devices' filters",
        reinitializeFiltersDevices: 'Select devices',
        reinitializeFiltersDevicesConfirmation:
            "Are you sure you want to reinitialize these devices' filters ? This action cannot be undone.",

        guntime: {
            now: 'Now',
            multipleGuntimes: 'Multiple guntime',
            name: 'Name',
            startAt: 'Start at',
            addGuntime: 'Add an other guntime',
            addGuntimeTitle: 'Create guntime'
        }
    },
    api: {
        error: {
            [EEventActions.CREATE_EVENT]: 'An error occured while creating the event {name}',
            [EEventActions.DELETE_EVENT]: 'An error occured while deleting the event {name}',
            [EEventActions.FETCH_EVENT]: 'An error occured while fetching the event',
            [EEventActions.FETCH_EVENTS]: 'An error occured while fetching the events',
            [EEventActions.UPDATE_EVENT]: 'An error occured while updating the event {name}',

            [EEventActions.SET_EVENT_FILTERS]: 'An error occured while settings the filters',
            [EEventActions.SET_GUNTIME]: 'An error occured while creating the guntime',
            [EEventActions.SYNC_CHECKPOINTS]:
                'An error occured while synchronizing the checkpoints',
            [EEventActions.SET_CHECKPOINTS_POSITIONS]:
                'An error occured while saving the order of the checkpoints'
        },
        success: {
            [EEventActions.CREATE_EVENT]: 'Event {name} successfully created !',
            [EEventActions.DELETE_EVENT]: 'Event {name} successfully deleted !',
            [EEventActions.FETCH_EVENT]: 'Event successfully fetched !',
            [EEventActions.FETCH_EVENTS]: 'Events successfully fetched !',
            [EEventActions.UPDATE_EVENT]: 'Event {name} successfully edited !',

            [EEventActions.SET_EVENT_FILTERS]: 'Filters successfully set !',
            [EEventActions.SET_GUNTIME]: 'Guntime successfully created !',
            [EEventActions.SYNC_CHECKPOINTS]: 'Checkpoints successfully synchronized !',
            [EEventActions.SET_CHECKPOINTS_POSITIONS]: "Checkpoints' order successfully saved !"
        }
    },
    createEvent: 'Create event',
    duplicatedEvent: 'Duplicated event',
    button: {
        addCheckpoint: 'Add a checkpoint',
        duplicateEvent: 'Duplicate',
        editEvent: 'Edit',

        saveCheckpointOrder: "Save checkpoints' order",
        editCheckpointOrder: "Edit checkpoints' order"
    },
    checkpoint: {
        name: 'Name',
        comment: 'Comment',
        detections: 'Reads',
        devicesList: 'Devices list',
        noDetectionFound: 'No detection found',
        noDeviceAssociated: 'No device associated'
    },
    detail: {
        informations: {
            informationsTitle: 'Information',
            eventLocalization: 'Event localization',
            guntimes: 'Guntimes',
            editTitle: 'Edit event',
            partnerConfigTitle: 'Partner configuration',
            partnerConfigUpdate: 'Partner update'
        },
        checkpoints: {
            checkpointsTitle: 'Checkpoints',
            createCheckpointTitle: 'Create new checkpoint',
            partner: 'Partner'
        },
        devices: {
            devicesTitle: 'Devices'
        },
        stats: {
            checkpointsCount: 'Checkpoints',
            onlineDevicesCount: 'Online devices',
            readsCount: 'Reads'
        }
    },
    detection: {
        table: {
            bib: 'Bib',
            checkpoint: 'Checkpoint',
            timestamp: 'Date',
            device: 'Device',
            event_filter: 'Event filter',
            timer_filter: 'Timer filter'
        },
        liveDetections: 'Live reads',
        pastDetections: 'Previous reads'
    },
    filters: {
        archived: 'Archived',
        clientId: 'Client ID',
        date_limit: 'Date',
        end_at: 'End date',
        endAt: 'End of event',
        endDate: 'End date',
        eventName: 'Event name',
        field: 'Field',
        future: 'Future',
        past: 'Past',
        period: 'Period',
        showFinished: 'Show finished events',
        showOngoing: 'Show ongoing events',
        showUpcoming: 'Show upcoming events',
        finished: 'Finished events',
        ongoing: 'Ongoing events',
        upcoming: 'Upcoming events',
        start_at: 'Start of event',
        startAt: 'Start of event',
        startDate: 'Start date'
    },
    model: {
        clientId: 'Client ID',
        eventId: 'Hub Event ID',
        comment: 'Comment',
        endAt: 'End date',
        name: 'Event name',
        currentPartner: 'Current partner',
        partnerName: 'Partner',
        partnerId: 'Partner ID',
        startAt: 'Start date',
        tz: 'Timezone'
    },
    table: {
        clientId: 'Client ID',
        comments: 'Comments',
        startDate: 'Start date',
        endDate: 'End date',
        eventName: 'Event name',
        duplicateEvent: 'Are you sure you want to duplicate this event ?',
        organizationName: 'Organization'
    },
    title: {
        datesTitle: "Event's dates",
        actionsTitle: 'Actions'
    }
}
